import React from 'react';
import styles from './index.module.scss';
import className from 'classnames/bind';
import PowerBy from 'components/power-by';

const cx = className.bind(styles);

/**
 * @param theme {'default','form'}
 */

const PageLayout = ({ theme = 'default', children, noCopyright = false, fullHeight = false }) => {
  const layoutStyles = cx({
    layout: true,
    'no-copyright': noCopyright,
    'full-height': fullHeight,
    [theme]: true,
  });

  return (
    <div className={layoutStyles}>
      <div className={styles.body}>{children}</div>
      {!noCopyright && <PowerBy />}
    </div>
  );
};

export default PageLayout;
